module.exports = __webpack_public_path__ + "static/pi0-7cfa27d23d4071aaf8b5d57805ca65b2.png";